var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "#003478"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41797 10.1221H7.81802V23.5898H3.41797V10.1221ZM19.8032 10.28C19.7565 10.2653 19.7122 10.2494 19.663 10.2359C19.6039 10.2226 19.5445 10.2112 19.4847 10.2017C19.2249 10.1488 18.9604 10.1221 18.6952 10.1221C16.1299 10.1221 14.503 11.9794 13.9668 12.6968V10.1221H9.56673V23.5898H13.9668V16.2437C13.9668 16.2437 17.292 11.6329 18.6952 15.0194V23.5898H23.094V14.5015C23.0922 13.5345 22.7681 12.5953 22.1726 11.8314C21.577 11.0674 20.7437 10.5218 19.8032 10.28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57004 8.28517C6.75859 8.28517 7.7221 7.3259 7.7221 6.14259C7.7221 4.95927 6.75859 4 5.57004 4C4.38148 4 3.41797 4.95927 3.41797 6.14259C3.41797 7.3259 4.38148 8.28517 5.57004 8.28517Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c48b73d1c66bf2f8e99cf1151f64356a.svg";
export { ForwardRef as ReactComponent };